import bemBlock from "@gik/core/utils/bemBlock";
import { Grid } from "@gik/ui-legacy/Grid";
import { SvgIcon } from "@gik/ui-legacy/SvgIcon/SvgIcon";
import HandIcon from "@heroicons/react/outline/HandIcon";
import HeartIcon from "@heroicons/react/outline/HeartIcon";
import NewspaperIcon from "@heroicons/react/outline/NewspaperIcon";
import UserGroupIcon from "@heroicons/react/outline/UserGroupIcon";
import type React from "react";
import { useTranslation } from "react-i18next";
import { translationKeys } from "./i18n/en";

export function BenefitsListGrid(): React.ReactElement {
	const bem = bemBlock("benefits-list-grid");
	const { t } = useTranslation();

	return (
		<Grid className={bem()}>
			<div className={bem("item")}>
				<SvgIcon
					Icon={HeartIcon}
					className={bem("icon", null, "tw-text-danger-600")}
					size="2xl"
				/>{" "}
				<br />
				<span className={bem("item-title tw-text-danger-600")}>
					{t(translationKeys.emotionalTitle)}
				</span>
				<p>{t(translationKeys.emotionalDescription)}</p>
			</div>
			<div className={bem("item")}>
				<SvgIcon
					Icon={NewspaperIcon}
					className={bem("icon", null, "tw-text-neutral-600")}
					size="2xl"
				/>
				<br />
				<span className={bem("item-title tw-text-neutral-900")}>
					{t(translationKeys.informationalTitle)}
				</span>
				<p>{t(translationKeys.informationalDescription)}</p>
			</div>
			<div className={bem("item")}>
				<SvgIcon
					Icon={HandIcon}
					className={bem("icon", null, "tw-text-info-600")}
					size="2xl"
				/>
				<br />
				<span className={bem("item-title tw-text-info-600")}>
					{t(translationKeys.tangibleTitle)}
				</span>
				<p>{t(translationKeys.tangibleDescription)}</p>
			</div>
			<div className={bem("item")}>
				<SvgIcon
					Icon={UserGroupIcon}
					className={bem("icon", null, "tw-text-secondary-600")}
					size="2xl"
				/>
				<br />
				<span className={bem("item-title tw-text-secondary-600")}>
					{t(translationKeys.belongingTitle)}
				</span>
				<p>{t(translationKeys.belongingDescription)}</p>
			</div>
		</Grid>
	);
}
